import * as React from 'react';
import CompetitionCardProps from './type';
import { DateAndCategory, Link, SvgImage } from '../common';
import './styles.scss';

const CompetitionCard = ({
  colourCode,
  dates,
  name,
  raceHubLink,
  venue,
  disciplineLink,
  label,
  isDownload,
  isPublished,
  publishingDate,
  isUciEvent,
  isLive,
}: CompetitionCardProps) => (
  <div className={`competition-card ${colourCode ? `competition-card--discipline-${colourCode}` : ''} ${isDownload ? 'competition-card--download' : ''}`}>
    <div className="competition-card__container">
      {isUciEvent && (
        <div className="competition-card__uci-logo">
          <SvgImage title="UCI event" reference="#icon-site-logo-small" />
        </div>
      )}
      {label && (
        <div className={`competition-card__label ${isLive ? 'competition-card__label--live' : ''}`}>
          {label}
        </div>
      )}
      <div className="competition-card__details">
        <div className="competition-card__category">
          <DateAndCategory category={disciplineLink} />
        </div>
        <div className="competition-card__name">
          {name}
        </div>
      </div>
      <div className="competition-card__footer">
        <div className="competition-card__dates">
          {dates}
        </div>
        <div className="competition-card__venue">
          {venue}
        </div>
        {isDownload && isPublished && (
          <div className="competition-card__publish-state">
            Published
          </div>
        )}
        {isDownload && publishingDate && (
          <div className="competition-card__publish-date">
            {publishingDate}
          </div>
        )}
        {raceHubLink && (
          <div className="competition-card__race-hub-link">
            <Link
              {...raceHubLink}
              iconAfter={{
                title: '',
                reference: isDownload ? '#icon-right-paddle' : '#icon-think-arrow',
              }}
            />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default CompetitionCard;
